























































import { Component, Prop, Vue } from 'vue-property-decorator'
import UserService from '@/services/UserService'
import { ResetPasswordData } from '@/interfaces/UserInterfaces'

@Component({ name: 'ResetPasswordForm' })
export default class ResetPasswordForm extends Vue {
  error: string | null = null
  passwordForm: ResetPasswordData = {
    newPassword: '',
    confirmPassword: ''
  }

  @Prop({ default: '' })
  email!: string

  @Prop({ default: '' })
  token!: string

  async submit () {
    if (!await this.$validator.validateAll()) {
      return
    }

    this.error = null
    this.errors.clear()
    this.$validator.reset()

    try {
      const passwordResponse = await UserService.resetPassword(this.email, this.token, this.passwordForm)
      this.$router.push({ name: 'home', params: { message: this.$tc('password_reset.success_message') } })
    } catch (error) {
      if ('response' in error && error.response.status === 400) {
        this.handleResetPasswordErrors(error.response.data, this.passwordForm)
      } else {
        throw error
      }
    }
  }

  handleResetPasswordErrors (response: any, formData: object) : void {
    Object.keys(response.errors).forEach((value: string) => {
      if (formData.hasOwnProperty(value) && value in response.errors && response.errors[value][0]) {
        this.errors.add({
          field: value,
          msg: response.errors[value].join('\n')
        })
      }
    })
  }
}
